<!--- COMPONENTE PCDistribuirPlanificacion  ---->
<!---
CASO DE USO: https://grupohispatec.sharepoint.com/:w:/s/Produccin/EQGVtEI-QZBGn5mlWlmWKuoBpbhZcHXi7Y9UhT25hgCQpQ?e=keizgg
Descripción del componente:
---------------------------

Eventos del componente:
-----------------------
-  xxxxxxxxxxx ->
--->
<template>
  <div
    v-if="salesOrderLine != null"
    class="main-main-pc-ditrubuir-planificacion "
  >
    <div class="content-gestion-linea">
      <f7-card-header class="padding-vertical">
        <div>
          {{ $t('production.manageProductionLines.distributeOrderPopup.labels.selectedOrder') }}
          <span class="card-header--large"> {{ salesOrderLine.Pedido }} </span>
        </div>
        <div>
          {{ $t('production.manageProductionLines.distributeOrderPopup.labels.maxQuantity') }}
          <span class="card-header--large"> {{ cantidadMaxima }}  </span>
        </div>
        <div>
          {{ $t('production.manageProductionLines.distributeOrderPopup.labels.distributed') }}
          <span class="card-header--large"> {{ cantidadDistribuida }} </span>
        </div>
      </f7-card-header>

      <f7-card>
        <f7-card-header>
          {{ $t('production.manageProductionLines.distributeOrderPopup.labels.destination') }}
        </f7-card-header>

        <f7-card-content>
          <div class="contenedit padding-bottom-half">
            <div>
              <f7-row
                class="content-location"
                :class="{ 'disabled-section': cantidadDisponible === 0 }"
              >
                <f7-col width="60">
                  <UCSearchEntityERP
                    ref="UCSearchNewRepartLine"
                    :placeholder="$t('searchEntity.line.placeholder.selectProductionLine')"
                    :search-text="$t('searchEntity.line.searchText')"
                    :search-cancellation-text="$t('searchEntity.line.searchCancellationText')"
                    :search-not-found-text="$t('searchEntity.line.searchNotFoundText')"
                    :min-text-search="0"
                    :property-entity-shown-input="['Nombre', 'Codigo']"
                    :emit-evet-change-default-value="true"
                    :property-entity-shown-list-title="['Nombre']"
                    :property-entity-shown-list-subtitle="['Codigo']"
                    :end-point-for-code-search="GetProductionLineCodeSearch"
                    :end-point-for-list="GetProductionLineList"
                    @selection="EventselectedNewLineDistribution"
                  />
                </f7-col>

                <f7-col
                  width="25"
                  class="content-location__stepper"
                >
                  <UCInputIncrement
                    ref="UCInputIncrementNewRepartLine"
                    :val="cantidadDisponible"
                    :max-valor="cantidadDisponible"
                  />
                </f7-col>

                <f7-col width="15">
                  <!-- Botones de Confirmación de cantidades modificadas -->
                  <f7-button
                    class="contenedit__option--confirm"
                    :disabled="cantidadDisponible === 0"
                    :title="$t('common.confirm')"
                    @click="ConfirmAddNewRepart"
                  >
                    <img
                      alt="iconDone"
                      src="@/static/icons/btn_done.svg"
                    >
                  </f7-button>
                </f7-col>
              </f7-row>
            </div>
          </div>
        </f7-card-content>
      </f7-card>

      <f7-card v-if="lstNewDistribution.length > 0">
        <f7-card-header>
          {{ $t('production.manageProductionLines.distributeOrderPopup.newDistribution.title') }}
        </f7-card-header>
        <f7-card-content>
          <div class="content-nueva-distribucion">
            <f7-row
              v-for="(item, index) of lstNewDistribution"
              :key="index"
              class="content-nueva-distribucion__item"
            >
              <f7-col
                width="60"
                class="content-nueva-distribucion__item--line"
              >
                {{ `${item.LineaProduccionDestino.Codigo} - ${item.LineaProduccionDestino.Nombre}` }}
              </f7-col>
              <f7-col width="25">
                <span class="content-nueva-distribucion__item--quantity-title">
                  {{ $t('production.manageProductionLines.distributeOrderPopup.newDistribution.quantity') }}
                </span>
                <span class="content-nueva-distribucion__item--quantity-number">
                  {{ item.Cantidad }}
                </span>
              </f7-col>
              <f7-col width="15">
                <f7-button
                  :title="$t('common.delete')"
                  @click="DeleteNewDistribution(item)"
                >
                  <img
                    alt="iconDelete"
                    src="@/static/icons/ic_DeleteNew.svg"
                  >
                </f7-button>
              </f7-col>
            </f7-row>
          </div>
        </f7-card-content>
      </f7-card>

      <div class="content-button padding-vertical-half">
        <div class="padding-horizontal-half">
          <f7-button
            color="gray"
            @click="Cancel"
          >
            {{ $t('common.cancel') }}
          </f7-button>
          <f7-button
            color="green"
            @click="Confirm"
          >
            {{ $t('common.confirm') }}
          </f7-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { LogDetails as Log } from '@/js/common/HIDebuggingSupport';
import UCSearchEntityERP from '@/components/common/UCSearchEntityERP.vue';
import ConexionTA, { callDistribuirPlanificacionXLineasProduccion } from '@/js/services/traceability/APITraceability';
import {
  HiNotification,
  PreloaderGH,
} from '@/js/common/HINotificationSupport';
import UCInputIncrement from '@/components/common/UCInputIncrement.vue';

/** @import { InfoDistribucionPlanificacion } from '@erpagroapp/types' */

export default {
  name: 'PCDistrubuirPlanificacion',
  components: {
    UCSearchEntityERP,
    UCInputIncrement,
  },

  props: {
    productionLine: {
      default: null,
      type: Object,
    },
    salesOrderLine: {
      default: null,
      type: Object,
    },
  },

  emits: [
    'change',
    'cancel',
  ],

  data() {
    return {
      productLineSelected: null, // linea de produccion actual
      lstNewDistribution: [],
      lineSelectedInSearch: null,
    };
  },
  computed: {
    cantidadMaxima() {
      return this.salesOrderLine?.CantidadPalet ?? 0;
    },
    cantidadDistribuida() {
      return this.lstNewDistribution.reduce((accumulator, object) => accumulator + object.Cantidad, 0);
    },
    cantidadDisponible() {
      return this.cantidadMaxima - this.cantidadDistribuida;
    },
  },
  watch: {
    productionLine(val) {
      this.productLineSelected = val;
    },
  },
  mounted() {
    this.StartComponent();
  },
  unmounted() {
    this.DestroyComponent();
  },
  methods: {
    StartComponent() {
      Log(this, this.StartComponent.name);
      this.lstNewDistribution = [];
    },
    DestroyComponent() {
      Log(this, this.DestroyComponent.name);
      this.ResetComponent();
    },
    /** @public */
    ResetComponent() {
      this.lstNewDistribution = [];
    },
    ConfirmAddNewRepart() {
      Log(this, this.ConfirmAddNewRepart.name);

      if (!this.ValidateE7(this.lineSelectedInSearch)) {
        HiNotification.Toast(this.$t('production.manageProductionLines.distributeOrderPopup.validation.noLineSelectedToastText'));
        return;
      }
      const numberNewRepart = this.$refs.UCInputIncrementNewRepartLine?.GetValue();
      if (numberNewRepart === 0) {
        HiNotification.Toast(this.$t('production.manageProductionLines.distributeOrderPopup.validation.minQuantityToastText'));
        return;
      }

      /** @type {InfoDistribucionPlanificacion} */
      const newobjPlanification = {
        LineaPedidoVenta: {
          Id: this.salesOrderLine.IdLineaPedidoVenta,
        },
        ParteProduccionPrevistoSalida: this.salesOrderLine.ParteProduccionPrevistoSalida,
        Cantidad: numberNewRepart,
        LineaProduccionDestino: this.lineSelectedInSearch,
      };
      const sameLine = this.lstNewDistribution.find((e) => e.LineaProduccionDestino.Id === this.lineSelectedInSearch.Id);
      if (sameLine === null || sameLine === undefined) {
        this.lstNewDistribution.push(newobjPlanification);
      } else {
        sameLine.Cantidad += newobjPlanification.Cantidad;
      }
    },
    /** DeleteNewDistribution */
    DeleteNewDistribution(elementRemove) {
      Log(this, this.DeleteNewDistribution.name);
      for (let i = 0; i < this.lstNewDistribution.length; i += 1) {
        if (this.lstNewDistribution[i].LineaProduccionDestino.Id === elementRemove.LineaProduccionDestino.Id) {
          this.lstNewDistribution.splice(i, 1);
        }
      }
    },
    async Confirm() {
      Log(this, this.Confirm.name);
      if (this.lstNewDistribution.length === 0) {
        HiNotification.Toast(this.$t('production.manageProductionLines.distributeOrderPopup.validation.minMovementsToastText'));
        return;
      }
      PreloaderGH(true, false, this.$t('production.manageProductionLines.distributeOrderPopup.action.preloaderText'), '');
      const result = await this.SENDNewListRepart(this.lstNewDistribution);
      PreloaderGH(false);
      if (result) {
        HiNotification.Toast(this.$t('production.manageProductionLines.distributeOrderPopup.action.successToastText'));
      }
      this.$emit('change');
      this.ResetComponent();
    },

    Cancel() {
      Log(this, this.Cancel.name);
      this.$emit('cancel');
      this.ResetComponent();
    },

    async EventselectedNewLineDistribution(newLine) {
      Log(this, this.EventselectedNewLineDistribution.name);
      if (!this.ValidateE4(newLine)) {
        HiNotification.Toast(this.$t('production.manageProductionLines.distributeOrderPopup.validation.sameLineToastText'));
        this.$refs.UCSearchNewRepartLine.Clear();
      } else {
        this.lineSelectedInSearch = newLine;
      }
    },

    // ValidateE4 - Misma línea producción origen y destino.
    ValidateE4(newLine) {
      Log(this, this.ValidateE4.name);
      if (newLine !== null && newLine.Id === this.productionLine.Id) {
        return false;
      }
      return true;
    },
    // ValidateE7 - No se ha indicado línea de producción .
    ValidateE7(newLine) {
      Log(this, this.ValidateE7.name);
      if (newLine === null || newLine === '') {
        return false;
      }
      return true;
    },

    GetProductionLineCodeSearch(params) {
      Log(this, this.GetProductionLineCodeSearch.name);
      return new Promise((resolve, reject) => {
        ConexionTA.callObtenerLineaDeProduccionPorCodigo(params).then((result) => {
          if (result.Valor) {
            resolve({ data: JSON.parse(result.Mensaje) });
          } else {
            reject(result.Mensaje);
          }
        });
      });
    },
    async GetProductionLineList() {
      Log(this, this.GetProductionLineList.name);
      return new Promise((resolve, reject) => {
        ConexionTA.callObtenerLineasDeProduccion().then((result) => {
          if (result.Valor) {
            resolve({ data: JSON.parse(result.Mensaje) });
          } else {
            reject(result.Mensaje);
          }
        });
      });
    },
    async SENDNewListRepart(lstNewDistribution) {
      Log(this, this.SENDNewListRepart.name);

      const res = await callDistribuirPlanificacionXLineasProduccion(lstNewDistribution).then((result) => {
        if (result.Valor) {
          return true;
        }

        HiNotification.Toast(this.$t('production.manageProductionLines.distributeOrderPopup.action.errorToastText', {
          error: result.Mensaje,
        }));
        return false;
      });
      return res;
    },
  },
};
</script>

<style lang="scss">
.main-main-pc-ditrubuir-planificacion {
  --f7-button-height: 46px;

  .contenedit {
    span {
      color: var(--his-oliva);
      font-size: 20px;
    }

    .contenedit__option {
      display: flex;
      align-items: center;
      justify-content: center;

      .contenedit__option--confirm {
        min-height: 85px;
      }

      .contenedit__option--delet {
        min-height: 20px;
      }
    }
  }

  .card-header {
    background-color: #ebecf0;
    font-size: 14px;
    --f7-card-header-font-size: 14px;
    --f7-card-header-text-color: var(--his-ajo);

    &--gray {
      color: var(--his-ajo-light);
    }

    &--strong {
      font-weight: 700;
    }

    &--large {
      font-size: 16px;
      font-weight: 700;
    }
  }

  .content-location {
    align-items: end;

    &__stepper {
      display: flex;
      align-items: end;
    }
  }

  .content-nueva-distribucion {
    &__item {
      display: flex;
      align-items: center;
      justify-content: space-between;

      div:nth-child(2) {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
      }

      &--quantity-title {
        color: var(--his-oliva);
        font-size: 14px;
        font-weight: 400;
      }

      &--quantity-number {
        color: var(--his-steel-blue);
        font-size: 24px;
        font-weight: 500;
      }

      &--line {
        color: var(--his-steel-blue);
        font-size: 18px;
        font-weight: 400;
      }
    }
  }

  .content-button {
    position: fixed;
    bottom: 0;
    width: 100%;

    > div {
      display: flex;
      justify-content: space-between;
      --f7-button-font-size: 16px;

      width: 100%;
    }
  }
}
</style>
